export default {"src":"__ASTRO_ASSET_IMAGE__DD$peH0m__","width":663,"height":442,"format":"png"}